import "../styles/Components/footer.css";

export default function Footer() {
  return (
    <footer>
      <div class='bloque1'>
        <p>© 2024 Tomas Fernandez Murga</p>
        <p>Todos los derechos reservados</p>
        {/* <p href='https://google.com'>Términos y Condiciones</p> */}
      </div>
    </footer>
  );
}
